import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, Chip, Column, DataRow, Row, Typography,
} from '@tempmee/react';

/** What the ticket wants shown when a rule does not constrain a dimension. */
export const ALL_TARGETS = 'All';

const joinOrAll = (values) => (values.length > 0 ? values.join(', ') : ALL_TARGETS);

/**
 * The "Targeting" card: who the code is for, as three readouts.
 *
 * Profession types and states are short codes and read fine as a list. DSOs
 * are stored on the rule as codes, which nobody in ops knows by heart, so the
 * page resolves them to names (via `useDsoNameResolver`) and passes them here
 * already resolved, as `{ code, name }` chips — this card holds no store
 * access of its own, so it renders from props alone.
 */
export const PromoCodeTargetingCard = ({ professions, states, dsos }) => (
  <Card outline className="flex-1 min-w-0">
    <Column px={5} py={4} gap={2}>
      <Typography variant="subtitle1" as="h2" bold className="text-text-secondary">
        Targeting
      </Typography>

      <DataRow label="Profession type" orientation="stacked" value={joinOrAll(professions)} />
      <DataRow label="State" orientation="stacked" value={joinOrAll(states)} />
      <DataRow
        label="DSO"
        orientation="stacked"
        divider={false}
        value={
          dsos.length > 0 ? (
            <Row gap={2} wrap="wrap" pt={1}>
              {dsos.map((dso) => (
                <Chip key={dso.code} label={dso.name} />
              ))}
            </Row>
          ) : (
            ALL_TARGETS
          )
        }
      />
    </Column>
  </Card>
);

PromoCodeTargetingCard.propTypes = {
  professions: PropTypes.arrayOf(PropTypes.string).isRequired,
  states: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** DSO targets, resolved to display names by the page. */
  dsos: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default PromoCodeTargetingCard;
